import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LoaderService } from 'src/app/services/helpers/loader.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  authorizeUrl = './authorize';

  constructor(private loaderService: LoaderService,
    @Inject(DOCUMENT) private document: Document) { }

  redirectToAuthorizeUrl() {
    this.loaderService.showLoader();
    this.document.location.href = this.authorizeUrl;
  }
}
